import './Loader.css';

const LoadingSpinner = ({ message = "Loading..." }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' , font:"20px" }}>
    <div className="loader"></div>
    <div className="loading-message">{message}</div>
  </div>
);

export default LoadingSpinner;
